import _ from 'underscore';
import { Formatter, ILogMessage } from '@bingads-webui/listener';
import { PiiRedactor } from '@bingads-webui/pii-redactor';

const redactMessage = (val: any, key: any) => {
  const value = (key === 'message') ? PiiRedactor.redact(val) : val;
  return { value };
};

export class OneDSPropertyFormatter extends Formatter {
  format(logMessage: ILogMessage): ILogMessage {
    return _.mapObject(logMessage, redactMessage);
  }
}
